import React, {useState} from "react";
import NotesService from "../components/admin/services/NotesService";
import {useSelector} from "react-redux";

function useAdminNotes(resourceId, resourceType, snackbar, fetchNotes, onNoteCreated) {
    const [open, setOpen] = useState(false);
    const session = useSelector((state) => state.adminLogin.adminUserSession);
    const fetch = () => fetchNotes(resourceId, session);
    const save = async(note) => {
        try {
            const response = await NotesService.create(session, {body: note, resource_id: resourceId, resource_type: resourceType})
            if(response.status === 'error') {
                snackbar.show(response.message, "warning");
            } else {
                // If there's transaction data in the response, call the callback
                if (response.data?.transaction && onNoteCreated) {
                    onNoteCreated(response.data.transaction);
                }
            }
        } catch (e) {
            console.error(e);
            snackbar.show("Error when creating note", "warning");
        }
    }

    return {
        open, setOpen,
        fetch, save, session
    };
}

export default useAdminNotes;